import { render, staticRenderFns } from "./deleteContractPartya.vue?vue&type=template&id=1e4874f5&scoped=true"
import script from "./deleteContractPartya.vue?vue&type=script&lang=js"
export * from "./deleteContractPartya.vue?vue&type=script&lang=js"
import style0 from "./deleteContractPartya.vue?vue&type=style&index=0&id=1e4874f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4874f5",
  null
  
)

export default component.exports